import Select from './Select';
import Panel from './Panel';
Select.Panel = Panel;
export default Select;
//# sourceMappingURL=index.js.map
